import React from "react";
import RenderIfVisible from 'react-render-if-visible'

import ReconnectingWebSocket from 'reconnecting-websocket';

import {CircularProgress, Modal, ModalClose, ModalDialog, Stack} from "@mui/joy";
import Box from "@mui/joy/Box";
import Tooltip from "@mui/joy/Tooltip";
import IconButton from "@mui/joy/IconButton";

// components
import BaseApi from "../../utils/BaseApi";
import CommentItem from "./CommentItem";
import {findArrayItemsByKeyValue} from "../../utils/misc";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommonForm from "../Common/CommonForm";

// icons
import SquareIcon from '@mui/icons-material/Square';
import SearchIcon from "@mui/icons-material/Search";


class CommentList extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            favComments: null,
            comments: null,
            searchModal: false,
            searchList: [],
        };
    }

    async componentDidMount() {
        await this.retrieveComments();
        await this.retrieveFavComments();
        let tokens;
        if (typeof localStorage.getItem("authTokens") === 'string'){
            tokens = JSON.parse(localStorage.getItem("authTokens"));
        }
        else {
            tokens = localStorage.getItem("authTokens");
        }
        this.client = new ReconnectingWebSocket(
            `${process.env.REACT_APP_WS_HOST}/ws/comment/${this.props.appName}/${this.props.appId}/`,
            [],
            {
                maxRetries: 10,
            }
        );
        this.client.onopen = () => {
            this.client.send(JSON.stringify({
                type: 'authenticate',
                access_token: tokens.access,
                refresh_token: tokens.refresh
            }));
            console.log("WebSocket Client Connected");
            this.setState(
                {
                    connected: true,
                }
            )
            this.retrieveLists()
            this.timer = setInterval(
                () => {
                    this.client.send(
                        JSON.stringify(
                            {
                                type: 'ping',
                            }
                        )
                    )
                },
                5000
            );
        };
        this.client.onclose = () => {
            console.log("WebSocket Client Disconnected");
            this.setState(
                {
                    connected: false,
                }
            )
        }
        this.client.onmessage = (message) => {
            this.handleMessage(message);
        };
    }

    handleMessage(message) {
        let data
        if (typeof message.data === 'string'){
            data = JSON.parse(message.data);
        }
        else {
            data =message.data;
        }
        switch (data.type) {
            case 'auth_success':
                console.log('Authenticated as', data.username);
                if (data.new_access_token) {
                    let tokens = JSON.parse(localStorage.getItem("authTokens"));
                    if (data.access_token){
                        tokens.access = data.access_token;
                    }
                    localStorage.setItem('authTokens', JSON.stringify(tokens));
                }
                break;

            case 'auth_error':
                console.error('Auth Error:', data.message);
                this.socket.close();
                break;

            case 'comment':
                let existingComments = findArrayItemsByKeyValue(
                    this.state.comments,
                    'id',
                    data.id
                )
                if (!existingComments.length) {
                    this.setState((state) => ({
                            comments: [
                                {
                                    id: data.id,
                                },
                                ...state.comments,
                            ],
                        })
                    );
                }
                break;

            case 'error':
                console.error('Server Error:', data.message);
                break;
        }
    }

    componentWillUnmount() {
        if (this.client) {
            this.client.close();
        }
        if (this.timer){
            clearInterval(this.timer);
        }
    }

    async retrieveLists() {
        this.setState(
            {
                searchModal: false,
                searchList: []
            }
        )
        await this.retrieveComments();
        await this.retrieveFavComments();
    }

    async retrieveFavComments() {
        const url = 'comment/';
        const params = {
            related_app_id: this.props.appId,
            related_app: this.props.appName,
            xtype: this.props.listXtypes,
            deleted_bool: 0,
            favorite: 1,
            page_size: 10000,
        };
        const api = new BaseApi();
        let response = await api.get(url, params, 'repeat');
        this.setState(
            {
                favComments: response.data.results
            }
        );
    }

    async retrieveComments() {
        const url = 'comment/ids/';
        const params = {
            related_app_id: this.props.appId,
            related_app: this.props.appName,
            xtype: this.props.listXtypes,
            deleted_bool: 0,
            page_size: 10000,
        };
        const api = new BaseApi();
        let response = await api.get(url, params, 'repeat');
        this.setState(
            {
                comments: response.data.results,
            }
        );
    }

    addComment(id) {
        if (id) {
            let existingComments = findArrayItemsByKeyValue(
                this.state.comments,
                'id',
                id
            )
            if (!existingComments.length){
                this.setState((state) => ({
                        comments: [
                            {
                                id: id,
                                read_by: [{id: this.context.userObject.id}]
                            },
                            ...state.comments,
                        ],
                    })
                );

            }
        }
    }

    async processSearch(form) {
        this.setState(
            {
                searchList: [],
            }
        );
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        const url = 'comment/';
        const params = {
            related_app_id: this.props.appId,
            related_app: this.props.appName,
            xtype: this.props.listXtypes,
            deleted_bool: 0,
            page_size: 10000,
            content: formDataObj.query
        };
        const api = new BaseApi();
        let response = await api.get(url, params, 'repeat');
        this.setState(
            {
                searchList: response.data.results,
            }
        );
    }

    render() {
        if (!this.state.comments) {
            return (<CircularProgress/>)
        }
        if (!this.state.favComments) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                direction={this.props.reverse ? 'column-reverse' : 'column'}
                spacing={2}
                sx={{
                    width: '100%',
                    alignItems: this.props.reverse ? 'flex-end' : 'flex-start',
                    overflowY: 'auto',
                    maxHeight: '100%',
                    flexGrow: 30,
                    mb: 2,
                    flexWrap: 'nowrap',
                }}
                id={'CommentListScrollableArea'}
            >
                <Stack
                    direction={'row'}
                    sx={{
                        width: '100%',
                        alignItems: "center",
                        flexWrap: 'wrap',
                        position: 'sticky',
                        top: this.props.reverse?null:0,
                        bottom: this.props.reverse?0:null,
                        zIndex: 1001,
                    }}

                >
                    {
                        this.state.comments.map(c => {
                            if (c.read_by){
                                return(
                                    <Tooltip
                                        title={
                                            c.owner&&c.created_on?`${c.owner.first_name} ${c.owner.last_name} от ${c.created_on}`:null
                                        }
                                        variant="soft"
                                    >
                                        <SquareIcon
                                            color={c.read_by.includes(this.context.userObject.id) ? 'neutral' : 'purple'}
                                            sx={{
                                                fontSize: '3px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                let comment = document.getElementById('CommentItemBox' + c.id);
                                                let area = document.getElementById('CommentListScrollableArea')

                                                area.scroll(0, comment.offsetTop - 50);

                                                let commentCard = document.getElementById('CommentItemCard' + c.id);
                                                if (commentCard){
                                                    commentCard.style.backgroundColor = 'purple';
                                                    commentCard.style.color = 'white';
                                                    setTimeout(()=>{
                                                        commentCard.style.backgroundColor = null;
                                                        commentCard.style.color = null;
                                                    }, 1000);
                                                }

                                            }}
                                        />
                                    </Tooltip>
                                )
                            }
                        })
                    }
                    <IconButton
                        size={'sm'}
                        onClick={() => {this.setState({searchModal: true})}}
                        sx={{
                            mt: 0,
                            mb: 0,
                            mr: 0,
                            minHeight: '16px',
                            minWidth: '16px',
                        }}
                        color={'primary'}
                        variant={'plain'}
                    >
                        <SearchIcon
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                    <Modal
                        open={this.state.searchModal}
                    >
                        <ModalDialog
                            layout={'center'}
                            size="sm"
                        >
                            <ModalClose
                                onClick={() => {
                                    this.setState({searchModal: false})
                                }}
                            />
                            <Box
                                sx={{
                                    overflowY: 'scroll',
                                    pr: 2,
                                    minWidth: '80vw'
                                }}
                            >
                                <CommonForm
                                    fields={
                                        [
                                            {
                                                'name': 'query',
                                                'label': 'Запрос',
                                                'xs': 12,
                                                'sm': null,
                                                'md': null,
                                                'lg': null,
                                                'xl': null,
                                                'required': true,
                                                'default': this.state.query,
                                                'type': 'input',
                                            },
                                            {
                                                'type': 'submit',
                                                'label': 'Искать',
                                            }
                                        ]
                                    }
                                    processForm={this.processSearch.bind(this)}
                                />
                                <Stack
                                    spacing={1}
                                >
                                    {this.state.searchList.map((c)=>(
                                        <CommentItem
                                            comment={c}
                                            user={this.context.userObject}
                                            key={'CommentItemSearch' + c.id}
                                            inlineReply={true}
                                            addCommentCallBack={this.retrieveLists.bind(this)}
                                        />)
                                    )}
                                </Stack>
                            </Box>
                        </ModalDialog>
                    </Modal>
                </Stack>
                {
                    !this.props.reverse ? this.state.favComments.map(each => {
                        return (
                            <Box
                                sx={{
                                    width: '100%'
                                }}
                                id={'CommentItemBox' + each.id}
                                key={'CommentItemBox' + each.id}
                            >
                                <CommentItem
                                    replyCallBack={this.props.replyCallBack}
                                    comment={each}
                                    favorite={true}
                                    user={this.context.userObject}
                                    callBack={this.retrieveLists.bind(this)}
                                    key={'CommentItem' + each.id}
                                />
                            </Box>

                        )
                    }) : null
                }
                {
                    this.state.comments.map(each => {
                        return (
                            <Box
                                sx={{
                                    width: '100%',
                                }}
                                id={'CommentItemBox' + each.id}
                                key={'CommentItemBox' + each.id}
                            >
                                {
                                    this.props.xtype === 'ALL' && this.props.appName === 'Opportunity'?
                                        <RenderIfVisible
                                            stayRendered={true}
                                            key={'RenderIfVisibleCommentItem-' + each}
                                            defaultHeight={200}
                                            visibleOffset={100}
                                        >
                                            <CommentItem
                                                inlineReply={true}
                                                addCommentCallBack={this.retrieveLists.bind(this)}
                                                comment={each}
                                                key={'CommentItem' + each.id}
                                            />
                                        </RenderIfVisible>:
                                        <RenderIfVisible
                                            stayRendered={true}
                                            key={'RenderIfVisibleCommentItem-' + each}
                                            defaultHeight={200}
                                            visibleOffset={100}
                                        >
                                            <CommentItem
                                                replyCallBack={this.props.replyCallBack}
                                                comment={each}
                                                callBack={this.retrieveLists.bind(this)}
                                                key={'CommentItem' + each.id}
                                            />
                                        </RenderIfVisible>
                                }
                            </Box>
                        )
                    })
                }
            </Stack>

        )
    }
}

export default CommentList;
